import { BasicInput } from '../withFormProps';
import React, { useEffect, useState } from 'react';
import { useCurrentStepIndex, useField, useForm } from '@kizi/comparator-core';
export type AccountHolderProps = {
  initialsFieldName: string;
  lastNameFieldName: string;
  middleNameFieldName: string;
  name: string;
};

export const AccountHolder: React.FC<AccountHolderProps> = ({
  initialsFieldName,
  middleNameFieldName,
  lastNameFieldName, // should be surnamefull
  name,
}) => {
  const accountHolderField = useField(name);
  const initialsField = useField('*.' + initialsFieldName);
  const surnameField = useField('*.' + lastNameFieldName);
  const middleNameField = useField('*.' + middleNameFieldName);
  const wizardStepIndex = useCurrentStepIndex() ?? '';
  const { send } = useForm(wizardStepIndex);
  if (!accountHolderField || !initialsField || !surnameField || !send)
    return null;
  const { errors, label, name: fieldNameWithoutFormName } = accountHolderField;

  const error = errors?.join('. ');

  useEffect(() => {
    const initials = initialsField.value
      ? `${initialsField.value
          .toString()
          .replace(/[^a-zA-Z]+/gi, '')
          .replace(/(.{1})/g, '$1.')} `
      : '';

    const fullName =
      initials +
      (middleNameField?.value ? middleNameField?.value + ' ' : '') +
      (surnameField.value ?? '');

    setState(fullName);
  }, [initialsField?.value, middleNameField?.value, middleNameField?.value]);

  const [state, setState] = useState<string | undefined>('');

  useEffect(() => {
    send?.({
      target: {
        name: accountHolderField.name,
        value: state,
      },
      type: 'CHANGE',
    });
  }, [state]);

  return (
    <BasicInput
      name={fieldNameWithoutFormName}
      _label={label}
      _error={error}
      onChange={(e) => setState(e.target.value)}
      value={state}
    />
  );
};
